var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", [
    _c(
      "ol",
      {
        ref: "list",
        staticClass: "navigation-list",
        style: _vm.getPixelTransform
      },
      _vm._l(_vm.menuItems, function(item, index) {
        return _c(
          "li",
          {
            key: "menu-item-" + index,
            ref: "listItems",
            refInFor: true,
            staticClass: "navigation-item",
            class: {
              "navigation-item--active":
                _vm.isActive && _vm.activeItemIndex === index
              //  'navigation-item--active': isActive && item.imgUrl,
            },
            style: _vm.getAppStyles(
              item,
              _vm.isActive && _vm.activeItemIndex === index
            )
          },
          [
            _vm.svgMarkup[index]
              ? _c("div", {
                  staticClass: "navigation-item__icon",
                  domProps: { innerHTML: _vm._s(_vm.svgMarkup[index]) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.getTitleText(item)
              ? _c(
                  "div",
                  {
                    staticClass: "navigation-item__title",
                    style: _vm.getAppTitleStyles(
                      _vm.isActive && _vm.activeItemIndex === index
                    )
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.getTitleText(item)) + "\n      "
                    )
                  ]
                )
              : _vm._e()
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23c7914b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c7914b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vod.vue
// module id = null
// module chunks = 